import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minToTime'
})
export class MinToTimePipe implements PipeTransform {

  transform(min: number): string {
    const minutes = min % 60;
    const hours = Math.floor(min / 60);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

}
